import { NextPage } from 'next'

import { MetaTags } from '~shared'
import { Layout } from '~ui'
import MainSection from '../components/saquon/main'
import AuctionsSection from '../components/saquon/auctions'
import ExperienceSection from '../components/saquon/experience'
import LegacySection from '../components/saquon/legacy'

const HomePage: NextPage = () => (
  <Layout>
    <MetaTags
      title="Saquon Barkley - NFT"
      description="Bid on an unforgettable experience with the uncomparable New York Giants Running Back, Saquon Barkley, and receive a limited edition SB Rookie NFT, exclusively provided on Granted."
      imageSrc={{
        path: '/1617993787029-diamond-access-package-nyg-vs-atl',
        extension: 'png',
      }}
    />
    <Layout.Header />
    <Layout.Main withSidebar={false}>
      <section>
        <MainSection />
        <LegacySection />
        <ExperienceSection />
        <AuctionsSection />
      </section>
    </Layout.Main>
    <Layout.Footer />
  </Layout>
)

export default HomePage
